import { useState } from "react";
import FormField from "../../formField/FormField";
import { useTranslation } from "react-i18next";
import "./customFieldsForm.scss";
import PropTypes from "prop-types";
import OutlinedPinkButton from "../../buttons/outlinedPinkButton/OutlinedPinkButton";
import GreenRedOutlinedButtons from "../../buttons/greenRedOutlinedButtons/GreenRedOutlinedButtons";

function CustomFieldsForm({
  customFields,
  handleFieldsChange,
  handleDeleteField,
  handleNewField,
  newCustomFieldError,
}) {
  const [fieldValue, setFieldValue] = useState("");
  const [addNewField, setAddNewField] = useState(true);
  const [showError, setShowError] = useState(false);

  const { t } = useTranslation("customFieldsForm");

  return (
    <section className="customFieldsContainer">
      <div className="customFieldsHeader">
        <p className="sectionTitle">{t("custom_fields")}</p>
        <OutlinedPinkButton onPressFunction={() => setAddNewField(!addNewField)}>
          {window.innerWidth <= 425
            ? addNewField
              ? "–"
              : "+"
            : addNewField
              ? t("dismiss")
              : t("add_new")}
        </OutlinedPinkButton>
      </div>
      {addNewField && (
        <div className="customFieldsForm">
          <FormField
            label={t("field_name")}
            placeholder={t("enter_field_name")}
            value={fieldValue}
            onChange={(field) => setFieldValue(field)}
            type="text"
            secondaryTheme
            error={showError ? newCustomFieldError : null}
          />
          <GreenRedOutlinedButtons
            greenName={t("add_field")}
            redName={t("cancel")}
            greenOnPress={() => {
              handleNewField(fieldValue);
              setShowError(true);
            }}
            redOnPress={() => {
              setFieldValue("");
              setShowError(false);
            }}
          />
        </div>
      )}

      <div className="customFields">
        {customFields?.map((customField) => (
          <div className="customField" key={customField.value}>
            <p className="customFieldName">{customField.value}</p>

            <div className="customFieldOptions">
              <div className="customFieldButtons">
                <button
                  onClick={() => handleFieldsChange(customField.value, false)}
                  className={`optionnalBtn ${customField.isMandatory ? "" : "active"}`}
                >
                  {t("optional")}
                </button>
                <button
                  onClick={() => handleFieldsChange(customField.value, true)}
                  className={`mandatoryBtn ${customField.isMandatory ? "active" : ""}`}
                >
                  {t("mandatory")}
                </button>
              </div>
              <button className="deleteButton" onClick={() => handleDeleteField(customField.value)}>
                X
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

CustomFieldsForm.propTypes = {
  customFields: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      isMandatory: PropTypes.bool.isRequired,
    }),
  ).isRequired,
  handleFieldsChange: PropTypes.func.isRequired,
  handleDeleteField: PropTypes.func.isRequired,
  handleNewField: PropTypes.func.isRequired,
  newCustomFieldError: PropTypes.string,
};

export default CustomFieldsForm;
